// extracted by mini-css-extract-plugin
module.exports = {"BottomContainer":"Drawer_BottomContainer__3Xxwy","headerStyle":"Drawer_headerStyle__3eCLE","hamburgerMenuButton":"Drawer_hamburgerMenuButton__kbP23","rtl":"Drawer_rtl__8lEX3"};